import { configureStore } from '@reduxjs/toolkit'
import { todoSlice } from '../features/api/todoSlice'
export const store = configureStore({
  reducer: {
    [todoSlice.reducerPath]: todoSlice.reducer,
  },
  middleware: (getDefualtMIddlewares) => getDefualtMIddlewares().concat(todoSlice.middleware),
})
